import React from 'react'
import { Classes, Dialog, Button } from '@blueprintjs/core'

import styles from './confirmStatusAlert.module.scss'

const ConfirmStatusAlert = ({
    showConfirmationModal,
    actionId,
    onConfirm,
    setConfirmationModal,
}) => {
    const handleConfirm = () => {
        onConfirm(actionId)
        handleCancel()
    }

    const handleCancel = () => {
        setConfirmationModal()
    }

    return (
        <Dialog
            icon="info-sign"
            onClose={handleCancel}
            isOpen={showConfirmationModal}
            title="Warning: overruling workflow"
        >
            <div className={Classes.DIALOG_BODY}>
                <p>
                    You are about to update an action that is still in 'Pending'
                    status. This may cause inconsistencies in the runbooks flow.
                    Do you want to proceed?
                </p>
            </div>
            <div className={Classes.DIALOG_FOOTER}>
                <div className={styles.footer}>
                    <Button intent="outlined" large onClick={handleCancel}>
                        Cancel
                    </Button>
                    <Button intent="danger" large onClick={handleConfirm}>
                        Update task
                    </Button>
                </div>
            </div>
        </Dialog>
    )
}

export default ConfirmStatusAlert
